import { Component, OnInit, AfterViewInit, Input, TemplateRef, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import {
  Schema, DynamicContentModel,
  SchemaMetadataModel, DynamicContentSchemaFacade,
  Field, ResourceFacade, LanguageModel,
  DataParser, SiteSettingFacade, DynamicContentSchemaFactory,
  UiNotificationService, Content, AssetFacade, SquidexDate,
  ScheduleJob, Asset, FilterPagination, AssetDirectoryFacade, AuthenticationService
} from '../../../services';
import { BaseComponent } from '../../../base/base-component.component';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, ValidatorFn, Validators, AbstractControl } from '@angular/forms';
import { Observable, of, forkJoin, combineLatest, Subject } from 'rxjs';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { FormGroupMapper } from '../../form-group/form-group-mapper.tool';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { AppSchemaCategory, AppToken, Statuses, FieldsName } from '../../../models/app-token';
import { guid, ID } from '@datorama/akita';
import { Validation, SquidexTool } from '../../../tools';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { ESchemaContentStatus } from '../../../services/akita/base/enum';
import { ContentInternalService } from '../../../services/squidex/services/content-internal.service';
import { Folder } from '../../../services/squidex/models/folder.model';
import { FolderList } from '../../../services/squidex/models/folder-list.model';
import { NgZone } from '@angular/core';
import { FieldReferenceModel } from "../../field-reference-editor/FieldReferenceModel.model";
import { SchemaMetadataFacade, DynamicSchemaFactory, SchemaPageFacade } from "../../../services/akita/index";
import { SchemasFactory } from "../../../services/squidex/factories/schemas.factory";
import { FieldReferenceContent } from "../../field/tools/field-reference-content.service";
import { FieldControlComponent } from "../../field/field-control.component";


@Component({
  selector: 'app-content-edition',
  templateUrl: './content-edition.component.html',
  styleUrls: ['./content-edition.component.css']
})
export class ContentEditionComponent extends BaseComponent implements OnInit {

  @Input()
  schemaDefinition: Schema;

  @Input()
  selectedContent: DynamicContentModel;

  @Input()
  schemaMetadata: SchemaMetadataModel;

  @Input()
  currentContentsFacade: DynamicContentSchemaFacade;

  @Input()
  referenceFieldValues: any;

  @Input()
  referenceFieldReferenceModel: FieldReferenceModel;

  @Input()
  monacoLanguage: string;

  @Input()
  selectableContents: Content[];

  @Input()
  contentCount: number;

  @Input()
  isSingle: boolean = false;

  @Input()
  isModal: boolean = false;

  @Input()
  showTitle: boolean = true;

  @Output()
  onContentChanged = new EventEmitter<any>();

  newImage: any[] = [];

  deletedAssets: any[] = [];

  folderParentId: string;
  folderList: FolderList;

  alreadyTried: boolean = false;

  editionFormGroup: FormGroup;
  publishFormGroup: FormGroup;

  unhiddenFields: Field[];
  hiddenFields: Field[];

  availableLanguages: LanguageModel[];
  dataParser: DataParser;

  modalRef: BsModalRef;
  bsConfig: Partial<BsDatepickerConfig>;
  isNew = false;

  userIsOwner: boolean;
  userIsDev: boolean;
  userIsEditor: boolean;
  userIsReadWrite: boolean;
  userIsReader: boolean;

  isDraft: boolean = false;
  statusColorClassName: string;
  scheduledJob: ScheduleJob;
  draftMode: boolean = false;
  currentStatus: string;
  draftVersionExist: boolean = false;
  publishMode: boolean = false;

  imageChange: boolean = false;
  cloneData: any;
  showAction: boolean = false;

  fieldReferenceModel: FieldReferenceModel;

  private isOpen: boolean;
  private isModified: boolean;
  private lastModified: string;
  private title: string;
  private contentType: string;
  private contentDefinition: any;


  @Input()
  hideFieldReferenceModelEditor: boolean;

  @Input()
  reloadOnUpdate: boolean;

  @Input()
  publishOnUpdate: boolean;

  @ViewChildren(FieldControlComponent) fieldControls: QueryList<FieldControlComponent>;

  constructor(
    private readonly resourceFacade: ResourceFacade,
    private readonly metadataFacade: SchemaMetadataFacade,
    private readonly schemasFactory: SchemasFactory,
    private readonly schemaPageFacade: SchemaPageFacade,
    private readonly contentFacadeFactory: DynamicContentSchemaFactory,
    private readonly dynamicSchemaFactory: DynamicSchemaFactory,
    private readonly referenceContentService: FieldReferenceContent,
    private readonly siteSettingFacade: SiteSettingFacade,
    private readonly modalService: BsModalService,
    private readonly uiNotificationService: UiNotificationService,
    readonly router: Router,
    private readonly spinnerService: SpinnerService,
    translateService: TranslateService,
    private readonly assetFacade: AssetFacade,
    private readonly contentInternalService: ContentInternalService,
    private readonly assetDirectoryFacade: AssetDirectoryFacade,
    private readonly authenticationService: AuthenticationService,
    private zone: NgZone,
  ) {
    super(translateService);
    this.setTranslateContext('ContentEditionComponent');
    this.reloadOnUpdate = true;
    //this.hideFieldReferenceModelEditor = true;
  }

  ngOnInit() {

    this.userIsOwner = this.authenticationService.userHasRole("Owner");
    this.userIsDev = this.authenticationService.userHasRole("Developer");
    this.userIsEditor = this.authenticationService.userHasRole("Editor");
    this.userIsReadWrite = this.authenticationService.userHasRole("ReadWrite");
    this.userIsReader = this.authenticationService.userHasRole("Reader");


    this.siteSettingFacade.getSiteLanguages().subscribe(languages => {
      this.availableLanguages = languages;
      this.dataParser = new DataParser(languages);
      this.initData(false);
      this.initEditionForm();
    });

    const subsDir = this.assetDirectoryFacade.getFolders().subscribe(fs => {
      this.folderList = fs;
    });
    this.subscriptions.push(subsDir);


  }

  toogleShowAction() {
    this.showAction = !this.showAction;
  }

  initData(retry: boolean) {
    this.bsConfig = Object.assign({},
      { containerClass: "theme-orange", dateInputFormat: AppToken.ISO_DATES_DATE_TIME_UPDATE });

    if (!this.selectedContent || retry) {
      this.selectedContent = new DynamicContentModel();
      this.isNew = true;

      const cloneData = localStorage.getItem("cloneData-" + this.schemaDefinition.name);

      if (cloneData) {
        this.cloneData = JSON.parse(cloneData);
        this.selectedContent.data = this.cloneData;
        localStorage.removeItem("cloneData-" + this.schemaDefinition.name);
      }

    } else {
      if (this.draftMode || (this.selectedContent.newStatus && !this.selectedContent.scheduleJob && !this.publishMode)) {
        this.currentStatus = this.selectedContent.newStatus;
        this.publishDateTime = '';
      } else {
        this.currentStatus = this.selectedContent.status;
        this.publishDateTime = this.dataParser.pullData(this.selectedContent, "publishdatetime");
      }

      if (this.publishDateTime.includes("1970-01-01")) {
        this.publishDateTime = '';
      }

      this.scheduledJob = this.selectedContent.scheduleJob;

      this.updateStatusAndStatusColor(this.currentStatus);

      // if (!this.publishDateTime) {
        this.draftVersionExisted();
      //}
      // this.getContentDefinition();

    }
  }

  initEditionForm() {
    if (!this.schemaDefinition) {
      return;
    }

    this.classifyFields();
    this.editionFormGroup = new FormGroup(
      this.generateFormGroup(
        this.currentContentsFacade,
        this.schemaDefinition.fields,
        this.hiddenFields.map(field => field.name),
        this.selectedContent)
    );

    this.createMetaDataFormGroup(this.selectedContent);

  }

  private createMetaDataFormGroup(content: DynamicContentModel): void {

    const fields = Object.keys(content);

    if (!fields.find(s => s === 'scheduleJob')) {
      fields.push('scheduleJob');
    }

    const metaDataFormGroup: any = {};
    let scheduledJob: boolean = false;

    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];

      if ((this.publishMode && content.newStatus) || (field === 'scheduleJob' && content.newStatus && content.newStatus === "Published")) {
        let fieldsValue = content.scheduleJob;
        scheduledJob = true
        if (!fieldsValue && content.newStatus) {
          fieldsValue = { id: null, dueTime: null, scheduledBy: null, status: null };
          fieldsValue.dueTime = this.publishDateTime;
          this.currentStatus = "Published";
        }
        const fs = Object.keys(fieldsValue);

        const scheduleJobFromGroup: any = {};

        for (let i = 0; i < fs.length; i++) {
          scheduleJobFromGroup[fs[i]] = this.createGenericFormControl(fs[i], fieldsValue);
        }

        metaDataFormGroup[field] = new FormGroup(scheduleJobFromGroup);
      } else {
        metaDataFormGroup[field] = this.createGenericFormControl(field, content);
      }
    }

    if (!scheduledJob) {
      let fieldsValue = { id: null, dueTime: null, scheduledBy: null, status: null };

      if (content.data.publishdatetime) {
        fieldsValue.dueTime = this.publishDateTime;
      }
      const fs = Object.keys(fieldsValue);
      const scheduleJobFromGroup: any = {};

      for (let i = 0; i < fs.length; i++) {
        scheduleJobFromGroup[fs[i]] = this.createGenericFormControl(fs[i], fieldsValue);
      }
      metaDataFormGroup['scheduleJob'] = new FormGroup(scheduleJobFromGroup);

    }

    this.publishFormGroup = new FormGroup(metaDataFormGroup);
  }


  private setJobStatusFormGroup(content: DynamicContentModel): void {

    const metaDataFormGroup: any = {};
    let scheduledJob: boolean = false;

    let fieldsValue = { id: null, dueTime: null, scheduledBy: null, status: null };

    if (content.data.publishdatetime && this.currentStatus === 'Published') {
      fieldsValue.dueTime = this.dataParser.pullData(content, 'publishdatetime');
    } else if (this.currentStatus === 'Draft') {
      fieldsValue.dueTime = null;
    } else {
      fieldsValue.dueTime = this.publishDateTime;
    }
    const fs = Object.keys(fieldsValue);
    const scheduleJobFromGroup: any = {};

    for (let i = 0; i < fs.length; i++) {
      scheduleJobFromGroup[fs[i]] = this.createGenericFormControl(fs[i], fieldsValue);
    }
    metaDataFormGroup['scheduleJob'] = new FormGroup(scheduleJobFromGroup);

    this.publishFormGroup = new FormGroup(metaDataFormGroup);
  }

  private createGenericFormControl(field: string, content: any, isRequired: boolean = false): FormControl {

    const fieldValue = content[field];

    const control = new FormControl(fieldValue);

    const validators: ValidatorFn[] = [];

    if (isRequired) {
      validators.push(Validators.required);
    }

    control.setValidators(validators);

    return control;
  }

  private updateStatusAndStatusColor(status: string) {
    switch (status) {
      case Statuses.PUBLISHED.name:
        this.isDraft = false;
        this.statusColorClassName = 'badge green-badge';
        break;
      case Statuses.DRAFT.name:
        this.isDraft = true;
        this.statusColorClassName = 'badge draft-badge';
        break;
      default:
        this.statusColorClassName = 'badge red-badge';
    }
  }

  private updateStatusSelect(e) {
    this.updateStatusAndStatusColor(e.target.value);
  }

  private draftVersionExisted() {
    if (!this.selectedContent.newStatus && this.selectedContent.status === 'Draft' && !this.selectedContent.scheduleJob) {
      this.draftVersionExist = true;
      this.draftMode = true;
      this.publishDateTime = '';
    } else {
      if (this.selectedContent.scheduleJob) {
        this.currentStatus = "Published"
      } else {
        this.currentContentsFacade.get(this.selectedContent.id, true).subscribe(p => {
          if (p.newStatus) {
            this.draftVersionExist = true;
            this.draftMode = true;
            this.publishDateTime = '';
          } else {
            this.draftVersionExist = false;
          }
        });
      }
    }
  }

  getFieldLabel(fieldName: string): Observable<string> {
    const resourceCode = `${this.schemaName}.${fieldName}.label`;
    return this.resourceFacade.getByCode(resourceCode).pipe(map(resource => {
      const value = resource.data.value[this.languageFacade.getDefaultLanguage()];
      if (resource && value) {
        return value as string;
      }
      return '';
    }),
      catchError(err => {
        return of('failed');
      }));
  }

  classifyFields(): void {
    if (!this.schemaMetadata) {
      return;
    }

    let hiddenFieldsNames = (this.schemaMetadata.data.hiddenfields.iv as string).split(';');
    this.unhiddenFields = [];

    this.hiddenFields = this.schemaDefinition.fields.filter(field => hiddenFieldsNames.filter(field => !this.isNew || field !== 'code')
      .some(hiddenFieldName => field.name === hiddenFieldName));

    //the point is to keep code first
    this.unhiddenFields = this.schemaDefinition.fields.filter(field => this.isNew && field.name === "code");

    this.unhiddenFields = this.unhiddenFields.concat(this.schemaDefinition.fields.filter(field => !hiddenFieldsNames
      .some(hiddenFieldName => field.name === hiddenFieldName)));

  }

  createContent(): void {
    this.alreadyTried = true;

    if (this.editionFormGroup.invalid) {
      this.editionFormGroup.markAllAsTouched();
      this.currentContentsFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.CONTENT_EDITION.INVALID_FORM, c.FAILED_TITLE, 10000);
      });
      console.error('Edition form group invallid : ');
      console.error(this.editionFormGroup);
      return;
    }

    if (this.selectableContents.map(c => c.data.code.iv).find(cn => cn === this.editionFormGroup.value['code'])) {
      this.currentContentsFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.CODE_TAKEN, c.FAILED_TITLE, 10000);
      });
      return;
    }

    let newContent = new DynamicContentModel(this.selectedContent);
    newContent = FormGroupMapper.GetContentFromFormGroup(this.editionFormGroup,
      newContent,
      this.schemaDefinition,
      this.availableLanguages);

    const squidexTool = new SquidexTool();
    let sanitizedCode = squidexTool.sanitizeForUniqueName(this.editionFormGroup.value['code']);

    newContent.data.code.iv = sanitizedCode;
    newContent.data['index'] = { 'iv': this.contentCount + 1 };

    if (this.schemaDefinition.category === AppSchemaCategory.SCHEMA_AS_A_PAGE) {
      const urls = new Array();
      for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
        urls.push(this.dataParser.pullData(newContent, 'url', language));
      }

      const urlsDistinct = [...new Set(urls)];
      if (urls.length > urlsDistinct.length) {
        this.currentContentsFacade.translate('T').subscribe(c => {
          this.uiNotificationService.error(c.URL_NOT_DISTINCT, c.FAILED_TITLE, 10000);
        });
        return;
      }
      let startWithSlash: boolean = true;
      urls.forEach(url => {
        if (url && !url.trim().startsWith('/')) {
          startWithSlash = false;
          console.log('Doesn\'t start with \'/\' while been a page... I guess :/');
          return;
        }
      });

      if (!startWithSlash) {
        this.currentContentsFacade.translate('T').subscribe(c => {
          this.uiNotificationService.error(c.URL_START_SLASH, c.FAILED_TITLE, 10000);
        });
        return;
      }


      let validateBatch: Observable<Number>[] = []

      for (const lg of this.availableLanguages.map(languages => languages.data.code.iv)) {

        let filterList: object[] = new Array();

        const allVersionParm = new FilterPagination();
        allVersionParm.from = 0;
        allVersionParm.to = 1;
        allVersionParm.filter = '';
        allVersionParm.orderBy = 'lastModified descending';


        for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
          let data: any = {};
          data = {
            path: `data.url.${lg}`,
            op: 'eq',
            value: this.dataParser.pullData(newContent, 'url', language)
          };

          filterList.push(data);
        }

        let orFilter: any = {};
        orFilter = {
          or: filterList
        }

        validateBatch.push(this.currentContentsFacade.validateUrl(allVersionParm, ESchemaContentStatus.All, orFilter));
      }

      forkJoin(validateBatch).subscribe(totalArr => {

        let total: number = 0;

        for (const num of totalArr) {
          total += num.valueOf();
        }

        if (total > 0) {
          this.currentContentsFacade.translate('T').subscribe(c => {
            this.uiNotificationService.error(c.URL_TAKEN, c.FAILED_TITLE, 10000);
          });
          return;
        }

        let hasImage = false;
        for (let i = 0; i < this.schemaDefinition.fields.length; i++) {
          const field = this.schemaDefinition.fields[i];
          if (field.properties.fieldType === 'Assets') {
            const idx = this.hiddenFields.findIndex(v => v.name === field.name)
            if (idx === -1) {
              this.dataParser.putData(newContent.data, field.name, '', 'iv', field);
              hasImage = true;
            }
          }
        }

        this.dataParser.putData(newContent, FieldsName.ISSECURE, false);
        this.dataParser.putData(newContent, FieldsName.ISNOINDEX, false);
        this.dataParser.putData(newContent, FieldsName.ISACTIVE, true);

        if (hasImage) {
          this.addImageField(newContent);
        } else {
          this.finalizeCreate(newContent);
        }

      });
    } else {

      if (!this.validatePatterns(newContent)) {
        return;
      }

      let hasImage = false;
      for (let i = 0; i < this.schemaDefinition.fields.length; i++) {
        const field = this.schemaDefinition.fields[i];
        if (field.properties.fieldType === 'Assets') {
          this.dataParser.putData(newContent.data, field.name, '', 'iv', field);
          hasImage = true;
        }
      }

      if (hasImage) {
        this.addImageField(newContent);
      } else {
        this.finalizeCreate(newContent);
      }
    }
  }

  getUrl(urlTree: any) {
    let url = `${urlTree.root.children['primary'].segments[0].path}`;
    if (urlTree.root.children['primary'].segments.length > 1) {
      url += `/${urlTree.root.children['primary'].segments[1].path}`;
    }
    return url;
  }

  updateContent() {
    this.alreadyTried = true;

    if (this.editionFormGroup.invalid) {
      this.editionFormGroup.markAllAsTouched();
      return;
    }

    let newContent = new DynamicContentModel(this.selectedContent);


    newContent = FormGroupMapper.GetContentFromFormGroup(this.editionFormGroup,
      newContent,
      this.schemaDefinition,
      this.availableLanguages);

    //Update status if published in future
    let dueTime = new Date(this.publishFormGroup.value.scheduleJob.dueTime ?? Date.now);

    let now = new Date();
    let publishStatus: string;

    if (this.selectedContent.newStatus) {
      publishStatus = this.selectedContent.newStatus;
    } else {
      publishStatus = this.selectedContent.status;
    }

    if ((publishStatus !== this.currentStatus) || this.publishFormGroup.touched) {
      this.currentStatus = 'Published';

      let publishDate: string = null;
      if (this.publishFormGroup.value.scheduleJob.dueTime > now) {
        publishDate = new SquidexDate(dueTime).format();
        this.dataParser.putData(newContent.data, 'publishdatetime', publishDate);
      } else {
        const dt = new SquidexDate(now).format();
        this.publishFormGroup.value.scheduleJob.dueTime = null;
        this.dataParser.putData(newContent.data, 'publishdatetime', dt);
      }

      this.currentContentsFacade.updateStatus(this.selectedContent.id, this.currentStatus, publishDate)
        .subscribe(content => {
          this.selectedContent = content;
          if (content.newStatus) {
            this.currentStatus = content.newStatus;
          } else {
            this.currentStatus = content.status;
          }
          this.scheduledJob = content.scheduleJob;
          this.updateStatusAndStatusColor(this.currentStatus);

          this.notify(this.currentStatus);
        });
    }
    else {
      let publishDate = this.dataParser.pullData(newContent, 'publishdatetime');
      if (publishDate.substring(0, 2) === '19') {
        publishDate = new SquidexDate(new Date()).format();
      }
    }

    //update images
    this.imageChange = false;

    for (let i = 0; i < this.schemaDefinition.fields.length; i++) {
      const field = this.schemaDefinition.fields[i];
      const elem: HTMLImageElement = document.querySelector('.thumbnail-div-' + field.name);
      if (elem && (elem.classList.contains("image-changed") || elem.classList.contains("image-deleted"))) {
        this.imageChange = true;
      }
    }

    const delImages = document.querySelector(".image-deleted");
    if (delImages) {
      this.imageChange = true;
    }

    if (this.deletedAssets.length > 0 || this.newImage.length > 0) {
      this.updateImageField(newContent);
    } else { // No image
      this.finalizeUpdate(newContent);
    }
  }

  updateImageField(newContent: DynamicContentModel) {
    const directoryName = 'Content-' + (this.selectedContent.schemaName ?? this.schemaDefinition.name);

    this.spinnerService.show();
    const folderExist: Folder = this.folderList.items.find(item => item.folderName === directoryName);
    if (!folderExist) {
      const folderNew = new Folder();
      folderNew.folderName = directoryName;
      const subs = this.assetDirectoryFacade.createFolder(folderNew).subscribe(f => {
        this.folderParentId = f.id;
        this.folderList.items.push(folderNew)
        this.finalizeUpdateImageField(newContent, directoryName);
      });
      this.subscriptions.push(subs);
    } else {
      this.folderParentId = folderExist.id;
      this.finalizeUpdateImageField(newContent, directoryName);
    }
  }

  finalizeUpdateImageField(newContent: DynamicContentModel, directoryName: string) {
    let assetsBatch: Observable<Asset>[] = []
    let deleteButKeepImage = false;

    for (let i = 0; i < this.schemaDefinition.fields.length; i++) {
      const field = this.schemaDefinition.fields[i]
      if (field.properties.fieldType === 'Assets') {

        let resultDelete: any = this.deletedAssets.find(e => e.fieldName === field.name);
        if (resultDelete) {
          resultDelete.assets.forEach(asset => {

            // Verify if image is used by other control. if so, don't delete
            Object.keys(this.editionFormGroup.controls).forEach((key) => {
              const ctrl = this.editionFormGroup.controls[key]
              if (Array.isArray(ctrl.value) && ctrl.value.length >= 1 && ctrl.value[0] === asset.id && field.name != key) {
                deleteButKeepImage = true;
              }
            });
            if (!deleteButKeepImage) {
              assetsBatch.push(this.assetFacade.remove(asset.id));
            }

            let assetVal: [] = this.dataParser.pullData(newContent, field.name);
            const idx = assetVal.findIndex(a => a === asset.id);
            if (idx > 0) {
              assetVal.splice(idx);
              newContent.data = this.dataParser.putData(newContent.data, field.name, assetVal);
            } else if (idx === 0) {
              assetVal = [];
              newContent.data = this.dataParser.putData(newContent.data, field.name, assetVal);
            }
          });
        }

        let result: any = this.newImage.find(e => e.fieldName === field.name);
        if (result) {
          result.files.forEach(file => {
            if (resultDelete && resultDelete.assets.find(e => e.id === file.id)) {
              return;
            }

            const formData = new FormData();
            formData.append('file', file);
            assetsBatch.push(this.assetFacade.create(formData, null, directoryName, field.name, '', this.folderParentId));
          });

          const assetValue = this.dataParser.pullData(newContent, field.name);
          if (!Array.isArray(assetValue)) {
            newContent.data = this.dataParser.setData(newContent.data, field, '');
          }
        }


      }
    }

    let index = 0;
    if (assetsBatch.length > 0) {
      combineLatest(assetsBatch).subscribe(assetsBack => {
        assetsBack.forEach((asset) => {
          let fieldName = '';
          if (asset) {
            const field = this.schemaDefinition.fields.find(obj => obj.name === asset.fieldName);
            if (field) {
              newContent.data = this.dataParser.setData(newContent.data, field, asset.id);
            }
          }
          index++;
          if (index === assetsBatch.length) {
            this.finalizeUpdate(newContent);
          }
        });
      },
        err => {
          // this.spinnerService.hide();
        }
      );

    } else if (deleteButKeepImage) {
      this.finalizeUpdate(newContent);
    } else {
      this.spinnerService.hide();
    }
  }

  addImageField(newContent: DynamicContentModel) {

    this.spinnerService.show();
    const directoryName = 'Content-' + (this.selectedContent.schemaName ?? this.schemaDefinition.name);

    const folderExist: Folder = this.folderList.items.find(item => item.folderName === directoryName);

    if (!folderExist) {
      const folderNew = new Folder();
      folderNew.folderName = directoryName;
      const subs = this.assetDirectoryFacade.createFolder(folderNew).subscribe(f => {
        this.folderParentId = f.id;
        folderNew.id = f.id;
        this.folderList.items.push(folderNew);
        this.finalizeUpdateImageField(newContent, directoryName);
      });
      this.subscriptions.push(subs);
    } else {
      this.folderParentId = folderExist.id;
      this.finalizeAddImageField(newContent, directoryName);
    }
  }

  finalizeAddImageField(newContent: DynamicContentModel, directoryName: string) {
    let assetsBatch: Observable<Asset>[] = []

    for (let i = 0; i < this.schemaDefinition.fields.length; i++) {
      const field = this.schemaDefinition.fields[i];
      if (field.properties.fieldType === 'Assets') {

        let resultDelete: any = this.deletedAssets.find(e => e.fieldName === field.name);
        if (resultDelete) {
          resultDelete.assets.forEach(asset => {
            assetsBatch.push(this.assetFacade.remove(asset.id));
          });
        }

        let result: any = this.newImage.find(e => e.fieldName === field.name);
        if (result) {
          result.files.forEach(file => {
            if (resultDelete && resultDelete.assets.find(e => e.id === file.id)) {
              return;
            }

            const formData = new FormData();
            formData.append('file', file);

            assetsBatch.push(this.assetFacade.create(formData, null, directoryName, field.name));
          });
        }
      }
    }

    if (assetsBatch.length > 0) {
      combineLatest(assetsBatch).subscribe(assetsBack => {
        assetsBack.forEach(asset => {
          if (asset) {
            const field = this.schemaDefinition.fields.find(obj => obj.name === asset.fieldName);
            if (field) {
              newContent.data = this.dataParser.setData(newContent.data, field, asset.id);
            }
          }

        });
        this.finalizeCreate(newContent);
        this.spinnerService.hide();
      },
        err => {
          this.spinnerService.hide();
        }
      );
    } else {
      this.finalizeCreate(newContent);
      this.spinnerService.hide();
    }
  }

  finalizeCreate(newContent: DynamicContentModel) {

    let createFunction: Observable<Content>;

    if (this.publishOnUpdate) {
      createFunction = this.currentContentsFacade.createAsPublished(newContent.data);
    }
    else {
      createFunction = this.currentContentsFacade.create(newContent.data);
    }

    const datePublished = new Date()
    datePublished.setHours(0, 0, 0, 0);
    const dt = new SquidexDate(datePublished.setHours(0, 0, 0, 0)).format();

    this.dataParser.putData(newContent.data, "publishdatetime", dt);


    const subscription = createFunction.subscribe(content => {
      const urlTree = this.router.parseUrl(this.router.url);
      const currentBaseUrl = this.getUrl(urlTree);

      if (this.schemaDefinition.category === AppSchemaCategory.SCHEMA_AS_A_PAGE) {
        //creation menu item
        const menuItemFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.MENU_ITEM_SCHEMA_NAME);
        let isExcu1 = false;

        let subs: any[] = [];

        const menuItemFacadeSub = menuItemFacade.getByCode(this.schemaDefinition.name);

        //creation schema-page relation page/content
        const pageFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_SCHEMA_NAME);

        let isExcu = false;
        const subSchemaPageFacade = pageFacade.getByCode(this.schemaDefinition.name);

        this.spinnerService.hide();

        combineLatest([menuItemFacadeSub, subSchemaPageFacade]).subscribe(val => {

          let parentMenuItem: any;

          let menuItemFacadeSub: any;
          let subPageFacade: any;

          val.forEach(v => {
            let item: any = v;
            if (item.schemaName === 'menu-item') {
              if (item && !isExcu1) {
                const newMenuItemData: any = {};
                const ids: string[] = [];
                ids.push(item.id);
                this.dataParser.putData(newMenuItemData, FieldsName.CODE, this.dataParser.pullData(content, 'code'));
                this.dataParser.putData(newMenuItemData, FieldsName.PAGE, content.id);
                this.dataParser.putData(newMenuItemData, FieldsName.PARENT_MENU_ITEM, ids);
                this.dataParser.putData(newMenuItemData, FieldsName.SCHEMA_NAME, this.schemaDefinition.name);
                this.dataParser.putData(newMenuItemData, FieldsName.INDEX, 0);
                isExcu1 = true;
                menuItemFacadeSub = menuItemFacade.createAsPublished(newMenuItemData);
                this.spinnerService.hide();
              }
            } else if (item.schemaName === 'page') {
              if (item && !isExcu) {
                const newSchemaPageData: any = {};
                this.dataParser.putData(newSchemaPageData, FieldsName.CODE, content.id);
                this.dataParser.putData(newSchemaPageData, FieldsName.PAGE_ID, item.id);
                this.dataParser.putData(newSchemaPageData, FieldsName.CONTENT_TYPE, this.schemaDefinition.name);
                this.dataParser.putData(newSchemaPageData, FieldsName.CONTENT_ID, content.id);
                this.dataParser.putData(newSchemaPageData, FieldsName.INDEX, 0);
                subPageFacade = this.schemaPageFacade.createAsPublished(newSchemaPageData);
                isExcu = true;
              }
              
            };
          });
          this.spinnerService.hide();
          combineLatest([menuItemFacadeSub, subPageFacade]).subscribe(() => {
            if (this.reloadOnUpdate) {
              this.currentContentsFacade.translate('T').subscribe(c => {
                this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
                this.router.navigateByUrl(`${currentBaseUrl}/${newContent.data.code.iv}`);
              });
            } else {
              this.currentContentsFacade.translate('T').subscribe(c => {
                this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
              });
            }
          });

        });
        this.executeContentChanged(content);
      } else {
        this.isNew = false;
        this.executeContentChanged(content);

        this.spinnerService.hide();
        if (this.reloadOnUpdate) {
          this.router.navigateByUrl(`${currentBaseUrl}/${newContent.data.code.iv}`);
        } else {
          this.currentContentsFacade.translate('T').subscribe(c => {
            this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
          });
        }
      }
    });
    this.subscriptions.push(subscription);
  }

  finalizeUpdate(newContent: DynamicContentModel) {
    if (this.schemaDefinition.category === AppSchemaCategory.SCHEMA_AS_A_PAGE) {

      const urls = new Array();
      for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
        urls.push(this.dataParser.pullData(newContent, 'url', language));
      }

      const urlsDistinct = [...new Set(urls)];
      if (urls.length > urlsDistinct.length) {
        this.currentContentsFacade.translate('T').subscribe(c => {
          this.uiNotificationService.error(c.URL_NOT_DISTINCT, c.FAILED_TITLE, 10000);
          this.spinnerService.hide();
        });
        return false;
      }
      let startWithSlash: boolean = true;
      urls.forEach(url => {
        if (!url.trim().startsWith('/')) {
          startWithSlash = false;
          return;
        }
      });

      if (!startWithSlash) {
        this.currentContentsFacade.translate('T').subscribe(c => {
          this.uiNotificationService.error(c.URL_START_SLASH, c.FAILED_TITLE, 10000);
          this.spinnerService.hide();
        });
        return false;
      }


      let validateBatch: Observable<Number>[] = []

      for (const lg of this.availableLanguages.map(languages => languages.data.code.iv)) {

        let filterList: object[] = new Array();

        const allVersionParm = new FilterPagination();
        allVersionParm.from = 0;
        allVersionParm.to = 1;
        allVersionParm.filter = '';
        allVersionParm.orderBy = 'lastModified descending';


        for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
          let data: any = {};
          data = {
            path: `data.url.${lg}`,
            op: 'eq',
            value: this.dataParser.pullData(newContent, 'url', language)
          };

          filterList.push(data);
        }

        let orFilter: any = {};
        orFilter = {
          or: filterList
        }

        validateBatch.push(this.currentContentsFacade.validateUrl(allVersionParm, ESchemaContentStatus.All, orFilter, this.selectedContent));
      }

      forkJoin(validateBatch).subscribe(totalArr => {

        let total: number = 0;

        for (const num of totalArr) {
          total += num.valueOf();
        }

        if (total > 0) {
          this.currentContentsFacade.translate('T').subscribe(c => {
            this.uiNotificationService.error(c.URL_TAKEN, c.FAILED_TITLE);
            this.spinnerService.hide();
          });
          return;
        }

        const subscription = this.currentContentsFacade.update(newContent.id, newContent.data).subscribe(() => {
          this.isNew = false;
          if (newContent.data.code.iv !== this.selectedContent.data.code.iv) {
            const urlTree = this.router.parseUrl(this.router.url);
            const currentBaseUrl = this.getUrl(urlTree);

            if (this.reloadOnUpdate) {
              this.router.navigateByUrl(`${currentBaseUrl}/${newContent.data.code.iv}`);
              return;
            }
          }
          this.selectedContent = newContent;
          this.currentContentsFacade.translate('T').subscribe(c => {
            this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
            this.resetImageElements();
            let setPublished: boolean = false;
            if (this.publishFormGroup.touched) {
              if (this.publishFormGroup.value.scheduleJob && this.publishFormGroup.value.scheduleJob.dueTime) {
                this.currentStatus = 'Published'
              }
            }
            this.setJobStatusFormGroup(this.selectedContent);
            this.spinnerService.hide();
          });
          this.executeContentChanged(newContent);
        });
        this.subscriptions.push(subscription);
      });

    } else {
      if (!this.validatePatterns(newContent)) {
        this.spinnerService.hide();
        return false;
      }

      const subscription = this.currentContentsFacade.update(newContent.id, newContent.data).subscribe(() => {
        if (this.reloadOnUpdate && newContent.data.code.iv !== this.selectedContent.data.code.iv) {
          const urlTree = this.router.parseUrl(this.router.url);
          const currentBaseUrl = this.getUrl(urlTree);
          this.router.navigateByUrl(`${currentBaseUrl}/${newContent.data.code.iv}`);
          return;
        }

        this.selectedContent = newContent;
        this.currentContentsFacade.translate('T').subscribe(c => {
          this.spinnerService.hide();
          if (this.imageChange) {
            this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
            this.reloadCurrentRoute();
          } else {
            this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE, 500);
          }
        });
        this.executeContentChanged(newContent);
      },
        err => {
          this.spinnerService.hide();
        });
      this.subscriptions.push(subscription);
    }
    return true;
  }

  resetImageElements() {
    this.deletedAssets = [];
    this.newImage = [];
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }


  closeModal(reload = false) {
    this.fieldReferenceModel = null;
    if (this.modalRef) {
        this.modalRef.hide();
    } else {
      this.modalService.hide();
    }
  }

  confirmDeleteContent() {

    if (this.selectedContent && Validation.isValidGuid(this.selectedContent.id)) {

      // Validate if content is used by a page
      let validationBatch: Observable<Content[]>[] = [];

      // Page content
      const pageContentFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_CONTENT_SCHEMA_NAME);
      const contentFilter = {
        path: 'data.contentid.iv',
        op: 'eq',
        value: this.selectedContent.id
      }
      validationBatch.push(pageContentFacade.getByObject(contentFilter, ESchemaContentStatus.All));

      // template
      const pageFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_SCHEMA_NAME);
      const templateFilter = {
        path: 'data.template.iv',
        op: 'eq',
        value: this.selectedContent.id
      }
      validationBatch.push(pageFacade.getByObject(templateFilter, ESchemaContentStatus.All));

      // layout
      const layoutFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_SCHEMA_NAME);
      const layoutFilter = {
        path: 'data.layout.iv',
        op: 'eq',
        value: this.selectedContent.id
      }
      validationBatch.push(layoutFacade.getByObject(layoutFilter, ESchemaContentStatus.All));


      const forkSusbcription = forkJoin(validationBatch).subscribe(contents => {
        let notValid = false;
        contents.forEach(c => {
          if (c.length > 0) {
            notValid = true;
          }
        });

        if (notValid) {
          this.closeModal();
          const subscription = this.currentContentsFacade.translate('T').subscribe(c => {
            this.uiNotificationService.error(c.CONTENT_BEING_USED, c.FAILED_TITLE);
            this.spinnerService.hide();
            this.subscriptions.push(subscription);
          });
          return;
        }

        let draftStatus: boolean = true;
        if (this.schemaDefinition.category === AppSchemaCategory.SCHEMA_AS_A_PAGE) {
          const schemaPageFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.SCHEMA_PAGE_SCHEMA_NAME);
          schemaPageFacade.getByParentId(this.selectedContent.id, 'contentid').subscribe(schemaPages => {
            schemaPages.forEach(sPage => {
              draftStatus = sPage.status.toLowerCase() === 'draft';
              schemaPageFacade.remove(sPage.id, draftStatus).subscribe();
            });
          });

          const menuItemFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.MENU_ITEM_SCHEMA_NAME);
          menuItemFacade.getByParentId(this.selectedContent.id, 'page').subscribe(menuItems => {
            menuItems.forEach(menuItem => {
              draftStatus = menuItem.status.toLowerCase() === 'draft';
              menuItemFacade.remove(menuItem.id, draftStatus).subscribe();
            });
          });
        }

        draftStatus = this.selectedContent.status.toLowerCase() === 'draft';
        const subscription = this.currentContentsFacade.remove(this.selectedContent.id, draftStatus).subscribe(() => {
          this.currentContentsFacade.translate('T').subscribe(c => {
            this.uiNotificationService.success(c.DELETE_SUCCESS, c.SUCCESS_TITLE);
            const urlTree = this.router.parseUrl(this.router.url);
            const currentBaseUrl = this.getUrl(urlTree);
            this.router.navigateByUrl(`${currentBaseUrl}`);
          });
        });
        this.subscriptions.push(subscription);
        this.closeModal();

      });

      this.subscriptions.push(forkSusbcription);
    }
  }

  // Currently still not executed.  this may be risky and not sure if needed
  removeReferences(refId: ID) {

    // get all schemas of category content
    let contentSchemas = this.dynamicSchemaFacto.getSchemasMetadataByCategory(AppSchemaCategory.CONTENT_SCHEMAS);
    this.removeSelectedSchema(contentSchemas, refId);

    contentSchemas = this.dynamicSchemaFacto.getSchemasMetadataByCategory(AppSchemaCategory.SCHEMA_AS_A_PAGE);
    this.removeSelectedSchema(contentSchemas, refId);
  }

  removeSelectedSchema(contentSchemas: any, refId: ID) {
    contentSchemas.subscribe(schemas => {
      for (const schema of schemas) {
        const schemaFacade = this.dynamicSchemaFacto.getDynamicSchemaFacade(schema.name);

        // Get fields from schema definition and loop
        schemaFacade.getSchemaDefinition().subscribe(schemaDef => {
          for (const field of schemaDef.fields) {

            // verify if field references the deleted content 
            if (field.properties.fieldType === "References" && field.properties.schemaIds[0] === this.schemaDefinition.id) {
              const contentsFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(schemaDef.name);
              let filterObj = {
                path: `data.${field.name}.iv`,
                op: "contains",
                value: refId
              }
              // get the content and delete reference if any
              contentsFacade.getByObject(filterObj, ESchemaContentStatus.All).subscribe(contents => {
                if (contents.length > 0) {
                  for (const content of contents) {
                    let dataClone = this.clone(content.data);
                    const idx = dataClone[field.name].iv.findIndex(x => x === refId);
                    if (idx >= 0) {
                      dataClone[field.name].iv.splice(idx, 1);
                      contentsFacade.update(content.id, dataClone).subscribe(
                      );
                    }
                  }
                }
              });
            }
          }
        });
      }
    });
  }

  private currentTime() {
    var current = new Date();
    return `${current.getHours().toString()}:${current.getMinutes().toString()}:${current.getSeconds()}:${current.getMilliseconds()}`
  }

  private confirmDeleteDrafts() {
    const subscription = this.currentContentsFacade.translate('T').subscribe(c => {
      this.deleteDraft();
    });
    this.closeModal();
    this.subscriptions.push(subscription);
  }

  redirectBase() {
    const urlTree = this.router.parseUrl(this.router.url);
    const currentBaseUrl = this.getUrl(urlTree);
    this.router.navigateByUrl(`${currentBaseUrl}`);
  }

  switchModeDratLive(event) {
    this.draftMode = event.srcElement.checked;

    this.currentContentsFacade.get(this.selectedContent.id, this.draftMode).subscribe(content => {
      this.selectedContent = content;

      if (this.draftMode) {
        if (this.draftMode && !this.selectedContent.newStatus) {
          this.createDraft();
        } else {
          this.initData(false);
          this.initEditionForm();
        }
      } else {
        this.draftMode = false;
        this.initData(false);
        this.initEditionForm();
      }
    });
  }

  reloadPage(draftMode: boolean) {
    this.draftMode = draftMode;

    this.currentContentsFacade.get(this.selectedContent.id, this.draftMode).subscribe(content => {
      this.selectedContent = content;

      if (this.draftMode) {
        this.createDraft();
        this.currentStatus = 'Draft';
        this.dataParser.putData(this.selectedContent.data, "publishdatetime", null);
        this.selectedContent.scheduleJob = null
        this.setJobStatusFormGroup(this.selectedContent);
      } else {
        this.draftMode = false;
        this.setJobStatusFormGroup(this.selectedContent);
      }
    });
  }

  private publish() {
    let publishStatus = Statuses.PUBLISHED.name;
    if (publishStatus === this.currentStatus) {
      this.notify(this.currentStatus, false);
      return false;
    }

    let publishDate: string;
    let updateDate: string;

    switch (publishStatus) {
      case Statuses.PUBLISHED.name:
        let dueTime = this.publishFormGroup.value.scheduleJob.dueTime;
        if (!dueTime) {
          dueTime = null;
          publishDate = null;
          updateDate = null;
        } else {
          const currentDate = new Date(Date.now());
          let dueTimeTemp = this.publishFormGroup.value.scheduleJob.dueTime;
          let dueTimeDate = new SquidexDate(dueTimeTemp);
          if (dueTimeDate < currentDate) {
            let now = new Date();
            publishDate = new SquidexDate(now).format();
            updateDate = null;
          } else {
            let dt = dueTimeDate;
            dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
            publishDate = new SquidexDate(dt).format();
            updateDate = publishDate;
          }
        }

        this.currentContentsFacade.updateStatus(this.selectedContent.id, publishStatus, updateDate)
          .subscribe(content => {
            const tempContent = this.clone(content);
            this.selectedContent = content;
            if (content.newStatus) {
              this.currentStatus = content.newStatus;
            } else {
              this.currentStatus = content.status;
            }
            this.draftMode = false;
            this.draftVersionExist = false;
            this.scheduledJob = content.scheduleJob;
            this.updateStatusAndStatusColor(content.status);
            if (!publishDate) {
              let now = new Date();
              publishDate = new SquidexDate(now).format();
            } else {
              let dt = new SquidexDate(publishDate);
              publishDate = new SquidexDate(dt).format();

            }

            this.dataParser.putData(tempContent.data, "publishdatetime", publishDate);
            this.publishMode = true;
            this.currentContentsFacade.update(this.selectedContent.id, tempContent.data).subscribe(content => {
              this.setJobStatusFormGroup(content);
              this.publishMode = false;
            });
            this.currentStatus = 'Published';
            this.notify(this.currentStatus);
          });

        break;
      case Statuses.DRAFT.name:
        this.currentContentsFacade.updateStatus(this.selectedContent.id, this.publishFormGroup.value.status, null)
          .subscribe(content => {
            this.selectedContent = content;
            if (content.newStatus) {
              this.currentStatus = content.newStatus;
            } else {
              this.currentStatus = content.status;
            }
            this.scheduledJob = content.scheduleJob;
            this.updateStatusAndStatusColor(content.status);
            this.notify(this.currentStatus);
          });
        break;
    }
    return false;
  }

  private notify(status: string, isSuccess: boolean = true): void {
    if (isSuccess) {
      this.currentContentsFacade.translate('T.STATUS_UPDATE', { currentStatus: status }).subscribe(msg => {
        this.currentContentsFacade.translate('T').subscribe(c => {
          this.uiNotificationService.success(msg, c.SUCCESS_TITLE, 10000);
        });
      });
    } else {
      this.currentContentsFacade.translate('T.STATUS_ERROR', { currentStatus: status }).subscribe(msg => {
        this.currentContentsFacade.translate('T').subscribe(c => {
          this.uiNotificationService.error(msg, c.FAILED_TITLE, 10000);
        });
      });
    }
  }

  createDraft() {
    this.currentContentsFacade.createDraft(this.selectedContent.id).subscribe(p => {
      this.draftMode = true;
      this.currentStatus = 'Draft';
      this.selectedContent = p;
    });
  }

  deleteDraft() {
    this.currentContentsFacade.removeDraft(this.selectedContent.id).subscribe(() => {
      this.draftVersionExisted();
      this.currentContentsFacade.translate('T').subscribe(c => {
        this.uiNotificationService.success(c.DELETE_SUCCESS, c.SUCCESS_TITLE);
        this.setJobStatusFormGroup(this.selectedContent);
      });
    });
  }

  newAsset(files: any) {
    this.newImage.forEach((image, index) => {
      if (image.fieldName === files.fieldName) {
        this.newImage.splice(index, 1);
      }
    });
    this.newImage.push(this.clone(files));
  }

  deleteAsset(file: any) {
    let resultIndex: any = this.deletedAssets.indexOf(e => e.fieldName === file.fieldName)

    if (resultIndex >= 0) {
      this.deletedAssets[resultIndex].assets.push(file.assets)
    } else {
      if (file.assets) {
        this.deletedAssets.push(file);
      }
    }

    this.newImage.forEach((image, index) => {
      if (image.fieldName === file.fieldName) {
        this.newImage.splice(index, 1);
      }
    });

  }


  validatePatterns(content: DynamicContentModel) {

    let isValid: boolean = true;
    const pattern = /^(\/|http:\/\/|https:\/\/)/;

    let validateUrl: string = this.dataParser.pullData(content, 'originalurl');
    if (validateUrl) {
      isValid = pattern.test(validateUrl);
    }

    if (isValid) {
      validateUrl = this.dataParser.pullData(content, 'redirectionurl');
      if (validateUrl) {
        isValid = pattern.test(validateUrl);
      }
    }

    if (!isValid) {
      this.currentContentsFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.URL_PATTERN_ERROR, 'Error', 5000);
        this.spinnerService.hide();
      });
    }

    return isValid;
  }

  updateForm(event: any) {
    this.editionFormGroup.value[event.field] = event.values;
    const content = this.clone(this.selectedContent);
    content.data[event.field] = { iv: event.values.map(v => v.item_id) };
    this.selectedContent = content;
    this.updateContent();
  }

  navigateToSchemaDefinition() {
    if (!this.schemaDefinition) {
      this.router.navigate(['/schemas/' + this.schemaDefinition.name]);
    }
  }


  redirectToClone() {
    this.contentInternalService.cloneContent(this.selectedContent.id, this.schemaDefinition.name);
  }

  copyContentCode() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.selectedContent.data.code.iv;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.uiNotificationService.successAsync(this.tc('COPY') as Observable<string>, this.t('SUCCESS_TITLE') as Observable<string>);
  }

  isReferenceField(field: Field) {
    if (!field.properties) {
      return false;
    }
    return field.properties.isReferenceField || field.properties.fieldType === "References";
  }

  executeContentChanged(content: DynamicContentModel) {
    if (!content) return;

    let label: string;

    if (content.data.Name) {
      label = content.data.Name[this.siteSettingFacade.getCurrentLanguage()];
      if (!label) {
        label = content.data.code.iv;
      }
    } else {
      label = content.data.code.iv;
    }

    const v = {
      Id: content.id,
      Code: content.data.code.iv,
      Label: label
    };

    const t = {
      value: v,
      fieldReferenceModel: this.fieldReferenceModel
    };

    if (this.onContentChanged) {
      this.onContentChanged.emit(t);
    }

    if (this.referenceFieldReferenceModel) {
      const control = this.referenceFieldReferenceModel.control as FieldControlComponent;
      if (control) {

        const n = control.referenceItems.concat({
          item_id: content.id,
          item_text: label
        });

        n.sort(function (a, b) {
          return a.item_text.localeCompare(b.item_text);
        });

        control.referenceItems = n;
      }
    }

    this.closeModal();
  }


  openFieldReferenceEditionModal(template: TemplateRef<any>, field: Field) {
    if (!field) {
      return;
    }

    this.fieldReferenceModel = new FieldReferenceModel();
    this.fieldReferenceModel.field = field;
    this.fieldReferenceModel.schemaId = field.properties.schemaIds[0];
    this.fieldReferenceModel.selectedContent = this.selectedContent;
    this.fieldReferenceModel.referenceFieldValues = this.referenceFieldValues;

    if (this.fieldControls) {
      this.fieldReferenceModel.control = this.fieldControls.find(v => v.field.name === field.name);
    }

    const sub = this.schemasFactory.getAllSchemas().subscribe(schemas => {
      const schema = schemas.find(v => v.id === this.fieldReferenceModel.schemaId);

      const facade = this.dynamicSchemaFactory.getDynamicSchemaFacade(schema.name);

      const sub2 = facade.getSchemaDefinition().subscribe(schemaDefinition => {
        this.fieldReferenceModel.schemaDefinition = schemaDefinition;

        const sub3 = this.metadataFacade.getBySchemaId(this.fieldReferenceModel.schemaId)
          .subscribe(v => {
            const sub5 = this.referenceContentService.generateContentList(schemaDefinition).subscribe(val => {
              this.fieldReferenceModel.referenceFieldValues = val;
              this.fieldReferenceModel.schemaMetadata = v;
              this.zone.run(() => {
                this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-styles' });
              });
            })
            this.subscriptions.push(sub5);
          });
        this.subscriptions.push(sub3);
      });

      this.subscriptions.push(sub2);
    });

    this.subscriptions.push(sub);

  }

  allowEditorEditing(field) {
    if (this.hideFieldReferenceModelEditor) {
      return false;
    }
    return this.isReferenceField(field) && (this.userIsDev || this.userIsOwner || this.userIsEditor || this.userIsReadWrite);
  }

  private getContentDefinition(): any {

    const contentType = this.dataParser.pullData(this.selectedContent, FieldsName.CONTENT_TYPE, 'iv');
    const contentId = this.dataParser.pullData(this.selectedContent, FieldsName.ID, 'iv');
    const pageContentIsModified = false;  // this.dataParser.pullData(this.selectedContent, FieldsName.ISMODIFIED, 'iv');
    let contentFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(contentType);

    contentFacade.get(contentId, this.isDraft).subscribe(articleContent => {
      this.contentDefinition = articleContent;

      this.title = this.getContentDefinitionCode();
      this.isModified = pageContentIsModified;
      this.lastModified = contentFacade.getLastModifiedDate(this.contentDefinition);
      this.contentType = contentType;
      this.pageContentDescription.emit(
        {
          title: this.title,
          isModified: this.isModified,
          lastModified: this.lastModified,
          isOpen: this.isOpen,
          contentType: this.contentType
        });
      contentFacade.getSchema().subscribe(articleSchema => {
        this.referenceContentService.generateContentList(articleSchema).subscribe((contents) => {
          this.referenceFieldValues = contents;
        });
        this.contentSchema = articleSchema;
        this.contentFields = articleSchema.fields.filter(field => !this.contentDefinitionHiddenFields.includes(field.name));
        this.createContentDefinitionForm(
          this.contentFields,
          articleContent,
          contentFacade);
      });
    });

    return null;
  }

}
